var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-pagination',{ref:"paginate",attrs:{"total-rows":_vm.total,"value":_vm.current_page,"per-page":_vm.per_page},on:{"change":function($event){_vm.current_page = $event;
    _vm.changePage($event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }